import React from 'react'
import LtsInputNumber from '../../../components/lottus/lts-input-number'
import storage from '../../../services/stoage.service'
import utils from '../../../utils'
import './ConfigRetornoRangeField.scss'

/**
 * Componente para editar um objeto com campos inicio e fim
 *
 * @param {Object} props.value - Objeto com { inicio: number, fim: number }
 * @param {Function} props.onChange - Callback chamado quando o objeto é alterado
 * @param {string} props.title - Título do campo (h4)
 * @param {Object} props.errors - Objeto com erros de validação { inicio: string, fim: string }
 * @returns {JSX.Element}
 */
export default function ConfigRetornoRangeField(props) {
  const { value = {}, onChange, title, errors = {} } = props

  const messages = storage.getAppLabels('configuracaoboleto')

  const handleChange = (field, newValue) => {
    const updatedValue = {
      ...value,
      [field]: newValue,
    }
    onChange?.(updatedValue)
  }

  return (
    <div className="config-retorno-range-field">
      <div className="card card-w-title">
        <h5>{title}</h5>

        <div className="p-grid form-group">
          <div className="p-col-12 p-md-6">
            <LtsInputNumber
              min={-1}
              value={value.inicio ?? null}
              onChange={(e) => handleChange('inicio', e)}
              name="inicio"
              label={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.inicio')}
              className={errors.inicio ? 'p-invalid' : ''}
            />
            {errors.inicio && <small className="p-error">{errors.inicio}</small>}
          </div>

          <div className="p-col-12 p-md-6">
            <LtsInputNumber
              min={-1}
              value={value.fim ?? null}
              onChange={(e) => handleChange('fim', e)}
              name="fim"
              label={utils.getMessage(messages, 'configuracaoboleto.label.configretorno.fim')}
              className={errors.fim ? 'p-invalid' : ''}
            />
            {errors.fim && <small className="p-error">{errors.fim}</small>}
          </div>
        </div>
      </div>
    </div>
  )
}
